import { render, staticRenderFns } from "./Disburses.vue?vue&type=template&id=1c23c389&scoped=true"
import script from "./Disburses.vue?vue&type=script&lang=js"
export * from "./Disburses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23c389",
  null
  
)

export default component.exports